import {
  REQUEST_REGISTRATION_USER,
  RESPONSE_REGISTRATION_USER,
  REQUEST_REGISTRATION_USER_FAILURE,
  READY_CHANGE_STORE_REGISTRATION,
  READY_CLEAR_STORE_REGISTRATION,
  REQUEST_REGISTRATION,
  RESPONSE_REGISTRATION,
  REQUEST_REGISTRATION_FAILURE,
} from "../actions/registrationActions";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  registrationUserDataState: states.NOT_REQUESTED,
  registrationUser: null,
  registrationItems: {},
  errors: null,
};

const registrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_REGISTRATION_USER:
      return Object.assign({}, state, {
        registrationUserDataState: states.REQUEST,
        registrationUser: null,
      });
    case RESPONSE_REGISTRATION_USER:
      return Object.assign({}, state, {
        registrationUserDataState: states.READY,
        registrationUser: action.data,
      });
    case REQUEST_REGISTRATION_USER_FAILURE:
      return Object.assign({}, state, {
        registrationUserDataState: states.FAILURE,
        errors: action.errors,
      });

    case READY_CHANGE_STORE_REGISTRATION: {
      const { name, value } = action.payload;
      const registrationItems = Object.assign({}, state.registrationItems);

      registrationItems[name] = value;

      return Object.assign({}, state, {
        registrationItems: registrationItems,
      });
    }
    case READY_CLEAR_STORE_REGISTRATION: {
      return Object.assign({}, state, {
        registrationItems: {},
      });
    }

    case REQUEST_REGISTRATION:
      return Object.assign({}, state, {
        dataState: states.REQUEST,
      });
    case RESPONSE_REGISTRATION:
      return Object.assign({}, state, {
        dataState: states.READY,
      });
    case REQUEST_REGISTRATION_FAILURE:
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default registrationReducer;
